import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {AutopayThresholdExceededPanel} from "./AutopayThresholdExceededPanel";
import {Messages} from "../../../../Messages";
import {iFrameState} from "../../../../services/IFrameState";
import {MessageElement} from "../../../../widget/ui/MessageElement";


export class UnexpectedErrorPanel extends AutopayThresholdExceededPanel {
    render() {
        const {styleSheet} = this;
         const {paymentRequestStatus} = iFrameState;

        return [
            <div className={styleSheet.container}>
                <MessageElement className={styleSheet.error}
                                message={Messages.unexpectedErrorIframe(paymentRequestStatus.error.message)}
                />
            </div>,
        ];
    }
}
